/*
 * Copyright (c) 2023. Collabro Limited
 */
import {
  Collapse,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Popover,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { PopoutScreenProps } from "./Options";
import { Close, ExpandLess, ExpandMore } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import QuickSearch from "../QuickSearch/QuickSearch";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import LayersList from "../Layers/LayersList";

const WrappedOptions = (props: PopoutScreenProps) => {
  const [openSearch, setOpenSearch] = useState(false);
  const [openLayers, setOpenLayers] = useState(false);
  const handleClose = () => {
    props.onClose(null);
  };

  const handleSearchButtonClicked = () => {
    setOpenSearch((prevState) => !prevState);
  };

  const handleOpenLayersButtonClicked = () => {
    setOpenLayers((prevState) => !prevState);
  };

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      {/*<div*/}
      {/*  style={{*/}
      {/*    padding: 10,*/}
      {/*    width: 200,*/}
      {/*  }}*/}
      {/*>*/}
      {/*    */}
      {/*</div>*/}
      <List
        dense
        sx={{ width: 300 }}
        component="nav"
        subheader={<ListSubheader component="div">More</ListSubheader>}
      >
        <ListItemButton onClick={handleSearchButtonClicked}>
          <ListItemIcon>
            <SearchIcon />
          </ListItemIcon>
          <ListItemText primary="Search" />
          {openSearch ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openSearch} timeout="auto" unmountOnExit>
          <List component="div" sx={{ padding: 1 }}>
            <QuickSearch containerWidth={null} variant="outlined" />
          </List>
        </Collapse>
        <ListItemButton onClick={handleOpenLayersButtonClicked}>
          <ListItemIcon>
            <AutoAwesomeMotionIcon />
          </ListItemIcon>
          <ListItemText primary="Layers" />
          {openLayers ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openLayers} timeout="auto" unmountOnExit>
          <LayersList
            onClose={handleOpenLayersButtonClicked}
            width={300}
            showHeader={false}
          />
        </Collapse>
      </List>
    </Popover>
  );
};

export default WrappedOptions;
